import { stringify } from 'qs'
import { get } from 'lodash'
import assert from './assert'

export const destinationOverviewPath = args => {
  assert(args, ['workspaceSlug', 'destinationMetadataSlug'])
  return `/${args.workspaceSlug}/destinations/${
    args.destinationMetadataSlug
  }/overview`
}

export const destinationSettingsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'destinationMetadataSlug'])
  return `/${args.workspaceSlug}/destinations/${
    args.destinationMetadataSlug
  }/sources/${args.sourceSlug}/configuration`
}

export const destinationSimulatorPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'destinationMetadataSlug'])
  return `/${args.workspaceSlug}/destinations/${
    args.destinationMetadataSlug
  }/sources/${args.sourceSlug}/validator`
}

export const destinationEventDeliveryPath = args => {
  const { workspaceSlug, sourceSlug, destinationMetadataSlug } = args
  const path = `/${workspaceSlug}/destinations/${destinationMetadataSlug}/sources/${sourceSlug}/event-delivery`

  if (args.query) {
    const period = get(args.query, 'period', '')

    const query = stringify({ period: period })

    return `${path}?${query}`
  }

  return path
}

export const destinationErrorPath = args => {
  assert(args, [
    'workspaceSlug',
    'sourceSlug',
    'destinationMetadataSlug',
    'type'
  ])

  const path = `/${args.workspaceSlug}/destinations/${
    args.destinationMetadataSlug
  }/sources/${args.sourceSlug}/event-delivery/${args.type}`

  if (args.query) {
    assert(args.query, 'period')

    const query = stringify({
      period: args.query.period
    })

    return `${path}?${query}`
  }

  return path
}

export const destinationsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/destinations`
}

export const destinationsCatalogPath = args => {
  assert(args, 'workspaceSlug')
  const path = `/${args.workspaceSlug}/destinations/catalog`

  if (typeof args.query === 'object' && args.query.category) {
    return `${path}?${stringify(args.query)}`
  }

  return path
}

export const destinationsCatalogWarehouseItemPath = args => {
  return `/${args.workspaceSlug}/destinations/warehouses/${
    args.warehouseMetadataSlug
  }`
}

export const destinationsCatalogItemPath = args => {
  assert(args, ['workspaceSlug', 'destinationMetadataSlug'])

  const path = `/${args.workspaceSlug}/destinations/catalog/${
    args.destinationMetadataSlug
  }`

  if (args.query) {
    assert(args.query, 'sourceSlug')

    const query = stringify({
      sourceSlug: args.query.sourceSlug
    })

    return `${path}?${query}`
  }

  return path
}

export const destinationsCatalogCategoryPath = args => {
  if (!args.category) {
    return `/${args.workspaceSlug}/destinations/catalog`
  }
  return `/${args.workspaceSlug}/destinations/catalog?category=${args.category}`
}
